const defaultState = null

const set = activatedCamera => (activatedCamera)

const activatedCameraState = { defaultState, set }
export default activatedCameraState
